type TimeAmount = {
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
};

export function duration(amount: TimeAmount): number {
    let result = 0;

    if (amount.days) {
        result += amount.days * duration({ hours: 24 });
    }
    if (amount.hours) {
        result += amount.hours * duration({ minutes: 60 });
    }
    if (amount.minutes) {
        result += amount.minutes * duration({ seconds: 60 });
    }
    if (amount.seconds) {
        result += amount.seconds * 1000;
    }

    return result;
}

export function millisecondsToString(milliseconds: number) {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    const string = seconds % 60;

    if (days > 0) {
        return `${days} days, ${hours}:${minutes}:${string}`;
    }

    if (hours > 0) {
        return `${hours}:${minutes}:${string}`;
    }

    if (minutes > 0) {
        return `${minutes}:${string}`;
    }

    if (seconds > 0) {
        return `${string} seconds`;
    }

    return `${milliseconds / 1000} seconds`;
}

export async function wait(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
